var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-template-manage-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "模板名称", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleFilter($event)
              },
            },
            model: {
              value: _vm.listQuery.keywords,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "keywords", $$v)
              },
              expression: "listQuery.keywords",
            },
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: {
                click: function ($event) {
                  return _vm.handleFilter()
                },
              },
            },
            [_vm._v("\n        搜索\n      ")]
          ),
          _vm._v(" "),
          !_vm.draftFlag
            ? _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  staticStyle: { "margin-left": "0" },
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: {
                    click: function ($event) {
                      return _vm.handleCreate()
                    },
                  },
                },
                [_vm._v("\n        创建模版\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.draftFlag
            ? _c(
                "el-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.handleCloseDraft },
                },
                [_vm._v("\n        返回列表\n      ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.tableKey,
          staticStyle: { width: "100%" },
          attrs: {
            "max-height": _vm.maxHeight,
            data: _vm.dataList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", prop: "id", align: "center", width: "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "模板名称",
              prop: "name",
              align: "center",
              "min-width": "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _vm.editingRowId === row.id
                      ? _c("el-input", {
                          ref: "nameInput",
                          attrs: { size: "mini" },
                          on: { blur: _vm.handleNameCancel },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleNameSave(row)
                            },
                          },
                          model: {
                            value: row.name,
                            callback: function ($$v) {
                              _vm.$set(row, "name", $$v)
                            },
                            expression: "row.name",
                          },
                        })
                      : _c(
                          "span",
                          {
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.handleNameEdit(row.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.name) +
                                "\n          "
                            ),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "菜品数量",
              prop: "goodsCount",
              align: "center",
              width: "120",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "模板类型",
              prop: "type",
              align: "center",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.type == 1 ? _c("span", [_vm._v("普通模板")]) : _vm._e(),
                    _vm._v(" "),
                    row.type == 2 ? _c("span", [_vm._v("分时模板")]) : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "状态",
              prop: "status",
              align: "center",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.status == 2
                      ? _c("span", [_vm._v("草稿")])
                      : _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-value": 1,
                            "inactive-value": 0,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleStatus(row.id, $event)
                            },
                          },
                          model: {
                            value: row.status,
                            callback: function ($$v) {
                              _vm.$set(row, "status", $$v)
                            },
                            expression: "row.status",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("tableFrom.Operation"),
              align: "center",
              width: "450",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(row.id)
                              },
                            },
                          },
                          [_vm._v("\n              编辑\n            ")]
                        ),
                        _vm._v(" "),
                        row.status != 1
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              删除\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        row.status == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "success",
                                  icon: "el-icon-switch-button",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleApplyDraft(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              应用草稿\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.draftFlag && row.draftId == null
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-document-copy",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDraftCopy(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              生成草稿\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.draftFlag
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-document-copy",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCopy(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              复制\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.draftFlag
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-document-copy",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDraft(row.id)
                                  },
                                },
                              },
                              [_vm._v("\n              草稿\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              icon: "el-icon-s-cooperation",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleCache(row.id)
                              },
                            },
                          },
                          [_vm._v("\n              缓存\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-sort",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleGroupSort(row)
                              },
                            },
                          },
                          [_vm._v("\n              分组排序\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "warning",
                              icon: "el-icon-s-promotion",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleSyncStatus(row.id)
                              },
                            },
                          },
                          [_vm._v("\n              一键下发\n            ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            key: "2",
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.editForm.id ? "编辑模板" : "新增模板",
            visible: _vm.editVisible,
            size: "500px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: {
                model: _vm.editForm,
                "label-width": "120px",
                rules: _vm.editRules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "name", $$v)
                      },
                      expression: "editForm.name",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模板类型", prop: "name" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: {
                        disabled: "",
                        placeholder: "模板类型",
                        clearable: "",
                      },
                      model: {
                        value: _vm.editForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "type", $$v)
                        },
                        expression: "editForm.type",
                      },
                    },
                    [
                      _c("el-option", {
                        key: "普通模板",
                        attrs: { label: "普通模板", value: 1 },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        key: "分时模板",
                        attrs: { label: "分时模板", value: 2 },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveEntity(null)
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }